// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: qxJZoN8JWK

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicGlowingText.module.css"; // plasmic-import: qxJZoN8JWK/css

createPlasmicElementProxy;

export type PlasmicGlowingText__VariantMembers = {
  variant:
    | "_default"
    | "editMode"
    | "sectionSettings"
    | "editingTitle"
    | "creating";
  glow: "none" | "blue" | "red";
};
export type PlasmicGlowingText__VariantsArgs = {
  variant?: SingleChoiceArg<
    "_default" | "editMode" | "sectionSettings" | "editingTitle" | "creating"
  >;
  glow?: SingleChoiceArg<"none" | "blue" | "red">;
};
type VariantPropType = keyof PlasmicGlowingText__VariantsArgs;
export const PlasmicGlowingText__VariantProps = new Array<VariantPropType>(
  "variant",
  "glow"
);

export type PlasmicGlowingText__ArgsType = {};
type ArgPropType = keyof PlasmicGlowingText__ArgsType;
export const PlasmicGlowingText__ArgProps = new Array<ArgPropType>();

export type PlasmicGlowingText__OverridesType = {
  root?: p.Flex<"div">;
};

export interface DefaultGlowingTextProps {
  variant?: SingleChoiceArg<
    "_default" | "editMode" | "sectionSettings" | "editingTitle" | "creating"
  >;
  glow?: SingleChoiceArg<"none" | "blue" | "red">;
  className?: string;
}

const $$ = {};

function PlasmicGlowingText__RenderFunc(props: {
  variants: PlasmicGlowingText__VariantsArgs;
  args: PlasmicGlowingText__ArgsType;
  overrides: PlasmicGlowingText__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "variant",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.variant
      },
      {
        path: "glow",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.glow
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.__wab_text,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootglobal_theme_dark_variant_editingTitle]:
            hasVariant($state, "variant", "editingTitle") &&
            hasVariant(globalVariants, "theme", "dark"),
          [sty.rootglobal_theme_dark_variant_sectionSettings]:
            hasVariant($state, "variant", "sectionSettings") &&
            hasVariant(globalVariants, "theme", "dark"),
          [sty.rootglow_blue]: hasVariant($state, "glow", "blue"),
          [sty.rootglow_red]: hasVariant($state, "glow", "red"),
          [sty.rootvariant__default]: hasVariant($state, "variant", "_default"),
          [sty.rootvariant_creating]: hasVariant($state, "variant", "creating"),
          [sty.rootvariant_editMode]: hasVariant($state, "variant", "editMode"),
          [sty.rootvariant_editingTitle]: hasVariant(
            $state,
            "variant",
            "editingTitle"
          ),
          [sty.rootvariant_sectionSettings]: hasVariant(
            $state,
            "variant",
            "sectionSettings"
          )
        }
      )}
    >
      {hasVariant($state, "variant", "creating")
        ? "Abort"
        : hasVariant($state, "variant", "editingTitle")
        ? "Discard Changes"
        : hasVariant($state, "variant", "sectionSettings")
        ? "Discard Changes"
        : hasVariant($state, "variant", "editMode")
        ? "Customize Layout"
        : hasVariant(globalVariants, "theme", "dark")
        ? "See All"
        : "See All"}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicGlowingText__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicGlowingText__VariantsArgs;
    args?: PlasmicGlowingText__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicGlowingText__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicGlowingText__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicGlowingText__ArgProps,
          internalVariantPropNames: PlasmicGlowingText__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicGlowingText__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicGlowingText";
  } else {
    func.displayName = `PlasmicGlowingText.${nodeName}`;
  }
  return func;
}

export const PlasmicGlowingText = Object.assign(
  // Top-level PlasmicGlowingText renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicGlowingText
    internalVariantProps: PlasmicGlowingText__VariantProps,
    internalArgProps: PlasmicGlowingText__ArgProps
  }
);

export default PlasmicGlowingText;
/* prettier-ignore-end */
